module.exports = __webpack_public_path__ + "img/tema0.0da7c172.svg";